
define('modules/application/wizard/steps/zoneStep/zoneMenuView',[
  "app",

  // Libs
  "backbone",
  "jqueryUi"
],

function(
  app,
  Backbone,
  jQueryUi) {

  var zoneMenuView = Backbone.View.extend({
    template  :  "application/wizard/steps/zones/menu-item",
    className :  "zone",
    tagName   :  "li",
    events    :  {
      "click" : "selectedZoneEventHandler"
    },

    initialize               : function()   {
      this.options.stepEventAggregator.unbind("order:changed",  this.render);
      this.options.stepEventAggregator.bind("order:changed",    this.render,         this);

      //this.options.stepEventAggregator.unbind("name:changed", this.render);
      this.model.bind("name:changed",                           this.render,         this);

      this.model.unbind("zone:valid",                           this.render);
      this.model.bind("zone:valid",                             this.render,         this);

      this.model.unbind("zone:invalid",                         this.render);
      this.model.bind("zone:invalid",                           this.render,         this);
    },

    serialize                : function()   {
      return { model: this.model };
    },

    cleanup                  : function()   {
      this.model.off(null, null, this);
    },

    selectedZoneEventHandler : function(e)  {
      if (e)
      {
        e.preventDefault();
        e.stopPropagation();
      }
      window.BticinoS4B.eventAggregator.trigger("zone:selected",this);
    },

    preventAnchor            : function(e)  {
      e.preventDefault();
      e.stopPropagation();
      window.BticinoS4B.eventAggregator.trigger("zone:selected",this);
    },

    beforeRender             : function()   {
      var isValid = this.model.isValid();
      //default degli ineritori Vale
      if(this.model.attributes.insertersModel || (this.model.attributes.technicalBusAlarmModel && this.model.attributes.technicalRadioAlarmModel))
        isValid=true;
      if (isValid)
      {
        this.$el.removeClass("partial");
        this.$el.addClass("completed");
      }
      else
      {
        this.$el.removeClass("completed");
        this.$el.addClass("partial");
      }
    }
  });

  // Required, return the module for AMD compliance
  return zoneMenuView;

});